import { IApplicationState } from '../../types/redux';
import { ERubric } from '../../types/rubricsLinks';

export function selectActiveRubric(state: IApplicationState): ERubric | null {
  return state.dropdown.activeRubric;
}
